import { JobDocumentEntityType } from "@/lib/supabase/supabaseTypes";
import React, { useState } from "react";
import { BookmarkPlus, BookmarkCheck } from "lucide-react";
import { JobDocumentNoteDialog } from "./job-document-note.dialog";
import { JobStatusEnum } from "@/lib/types/job";
import { cn } from "../../lib/util";
import { TooltipWrapper } from "../ui/tooltip-wrapper";

export const JobDocumentNote: React.FC<{
	jobDocument: JobDocumentEntityType;
}> = ({ jobDocument }) => {
	const note = jobDocument.note || null;
	const [jobDocumentNoteDialogOpen, setJobDocumentNoteDialogOpen] =
		useState(false);

	const tooltip = note ? note : "Hinweis hinzufügen";
	const editable = jobDocument.status === JobStatusEnum.IN_PROGRESS;

	return (
		<>
			<TooltipWrapper
				title={
					editable
						? tooltip
						: "Dieses Dokument ist nicht im Bearbeitungsmodus"
				}
				position="right"
			>
				<button
					className={cn(
						"ml-2.5 inline-flex items-center justify-center rounded p-1 transition-colors",
						editable
							? "hover:bg-accent cursor-pointer"
							: "cursor-not-allowed opacity-50"
					)}
					onClick={() =>
						editable && setJobDocumentNoteDialogOpen(true)
					}
					disabled={!editable}
					aria-label={
						note ? "Hinweis bearbeiten" : "Hinweis hinzufügen"
					}
					data-testid="job-document-note-button"
				>
					{note ? (
						<BookmarkCheck
							className={cn(
								"w-4 h-4",
								editable ? "text-green-500" : "text-gray-400"
							)}
						/>
					) : (
						<BookmarkPlus className="w-4 h-4 text-muted-foreground" />
					)}
				</button>
			</TooltipWrapper>
			<JobDocumentNoteDialog
				open={jobDocumentNoteDialogOpen}
				onClose={() => setJobDocumentNoteDialogOpen(false)}
				jobDocument={jobDocument}
			/>
		</>
	);
};
